import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledIconButtonWrapper = styled.div<{ $isDisabled?: boolean }>`
    cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "default")};

    &:hover {
        .SWReactIcons svg use {
            fill: ${({ $isDisabled }) => ($isDisabled ? colorsPalettes.carbon[200] : colorsPalettes.blue[500])};
        }
    }

    .SWReactIcons svg use {
        fill: ${({ $isDisabled }) => ($isDisabled ? colorsPalettes.carbon[200] : colorsPalettes.blue[400])};
    }
`;
